import { Link } from 'react-router-dom'
import { Button, Space, Typography } from 'antd'
import { CheckOutlined, MessageOutlined, RocketOutlined } from '@ant-design/icons'
import { landingCopy, productName } from '../branding'

const { Title, Paragraph } = Typography

export default function LandingPage() {
  const copy = landingCopy()
  const name = productName()

  return (
    <div style={{ maxWidth: 980, margin: '0 auto', padding: '48px 20px 80px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Space>
          <MessageOutlined style={{ fontSize: 22, color: '#1d4ed8' }} />
          <span className="display" style={{ fontSize: 22, fontWeight: 700, color: '#0f172a' }}>
            {name}
          </span>
        </Space>
        <Space>
          <Link to="/login">
            <Button type="text" style={{ color: '#0f172a', fontWeight: 600 }}>
              Log in
            </Button>
          </Link>
          <Link to="/signup">
            <Button type="primary">Start — $20/mo</Button>
          </Link>
        </Space>
      </div>

      <div style={{ marginTop: 72, maxWidth: 720 }}>
        <Title className="display" style={{ color: '#0f172a', fontSize: 52, lineHeight: 1.08, marginBottom: 16 }}>
          Facebook Messenger AI for $20 a month
        </Title>
        <Paragraph style={{ color: '#334155', fontSize: 18, maxWidth: 560, marginBottom: 24 }}>
          {copy.heroSupport}
        </Paragraph>
        <Space size="middle" wrap>
          <Link to="/signup">
            <Button type="primary" size="large" icon={<RocketOutlined />}>
              Buy {name} — $20/mo
            </Button>
          </Link>
          {copy.showServiceFlowCta && (
            <a href={copy.serviceFlowCtaHref}>
              <Button size="large" style={{ borderColor: '#94a3b8', color: '#0f172a' }}>
                {copy.serviceFlowCtaLabel}
              </Button>
            </a>
          )}
        </Space>
      </div>

      <div
        style={{
          marginTop: 64,
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
          gap: 16,
        }}
      >
        {[
          'One-click Facebook Page connect',
          'Upload your own FAQ knowledge base',
          'AI replies grounded in your content',
          copy.featureStandalone,
        ].map((item) => (
          <div key={item} className="feature-tile">
            <CheckOutlined style={{ color: '#0284c7', marginRight: 8 }} />
            {item}
          </div>
        ))}
      </div>
    </div>
  )
}
